angular.module( 'acme.view.application.membership.detail.modals.cardholderExpiration', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.detail.modals.cardholderExpiration.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipDetailModalsCardholderExpiration = {
        name: 'application.membership.detail.modals.cardholderExpiration',
        url: '/membership/detail/modals/cardholderExpiration',
        views: {
          "main": {
            controller: 'MembershipDetailModalsCardholderExpirationController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/detail/modals/cardholderExpiration/cardholderExpiration.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipDetailModalsCardholderExpiration);
});
